import React from "react";

const IconCloud = ({ width = "26", height = "17" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 26 17"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.43702 15.7719H21.7909C21.7909 15.7719 24.6272 15.2402 24.6858 12.4072C24.6858 12.4072 24.801 8.68305 21.5584 8.68609C21.5584 8.68609 20.6901 4.79274 16.0011 5.20598C16.0011 5.20598 14.3222 0.778869 9.28443 1.48684C9.28443 1.48684 4.36291 2.54931 4.42152 7.5669C4.42152 7.5669 0.967325 8.92511 1.00508 12.1713C1.00508 12.1713 0.773603 15.1814 3.43702 15.7719Z"
        stroke="#006F94"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default IconCloud;
